import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as OfflinePluginRuntime from 'offline-plugin/runtime';
import LogRocket from 'logrocket';
import { store } from 'store/store';
// Needed for mails
// Temporarily imported here as an ugly workaround for a technical problem on
// the server side that breaks serving of static files
import fileIcon from 'assets/images/icon-file.png'; // eslint-disable-line
import folderIcon from 'assets/images/icon-folder.png'; // eslint-disable-line
import TagManager from "react-gtm-module";
import { createBrowserHistory } from 'history';
import CustomRouter from 'base/components/CustomRouter';
import App from './App';


export const history = createBrowserHistory();
LogRocket.init('fyb5kg/bucher-intranet');

export const tagManagerArgs = {
    gtmId: 'GTM-PWR3TWGQ'
}
TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <Provider store={store}>
    <CustomRouter history={history}>
      <App />
    </CustomRouter>
  </Provider>,
  document.getElementById('app'),
);

OfflinePluginRuntime.install({
  onUpdateReady: () => OfflinePluginRuntime.applyUpdate(),
  onUpdated: () => (window.swUpdate = true), // eslint-disable-line
});

export { store }; // eslint-disable-line
